import { internalFetch } from '../utils/fetchHelper';

export interface ITrackingDevice {
  id: number;
  isActive: boolean;
  type: string;
  code: string;
  name: string;
}

export const getActiveTrackingDevices = async (
  abortController: AbortController,
  search?: string
): Promise<ITrackingDevice[]> => {
  return internalFetch(
    `${import.meta.env.VITE_BACKEND_API_URL}/p/activeTrackingDevices?${
      search ? `&search=${search}` : ''
    }&code=${import.meta.env.VITE_BACKEND_API_KEY}`,
    'GET',
    abortController
  );
};
